/* ============================================================
   RF Scoring V4 – scores + exclusions (perfected)
============================================================ */

const PEMRF_SCORING_V5 = {
  age: {
    "15_20": { hydrazone: 1,    eye_flash: 1 },
    "20_30": { rice_ritual: 1,  eye_flash: 1 },
    "30_40": { rice_ritual: 1, eye_flash: 1 },
    "40_50": { cosmopolitan: 1, eye_flash: 1 },
    older:   { cosmopolitan: 1, eye_flash: 1 }
  },
  skin_type: {
    normal:      { day_maker: 1, pink_cloud: 1, lumiskin: 1 },
    dry:         { day_maker: 1, milky_glow: 1, matcha_spa: 1 },
    combination: { perfector: 1, milky_glow: 1, firm_therapy: 1 },
    oily:        { perfector: 1, glass_skin: 1, matcha_spa: 1 }
  },
  concerns: {
    pores:        { perfector: 2, glass_skin: 2, purist: 1, hydrazone: 2, matcha_spa: 1 },
    acne:         { perfector: 2, glass_skin: 2, purist: 1, hydrazone: 2, matcha_spa: 1 },
    wrinkles:     { day_maker: 2, pink_cloud: 2, age_expert: 1, cosmopolitan: 2, water_plump: 1, firm_therapy: 1 },
    sagging:      { day_maker: 2, pink_cloud: 2, age_expert: 1, cosmopolitan: 2, water_plump: 1, firm_therapy: 1 },
    dehydrated:   { day_maker: 2, milky_glow: 2, rosie: 1, cosmopolitan: 2, water_plump: 1, firm_therapy: 1 },
    pigmentation: { perfector: 2, glass_skin: 2, purist: 1, rice_ritual: 2, lumiskin: 1 },
    sensitive:    { day_maker: 2, milky_glow: 2, rosie: 1, rice_ritual: 2, matcha_spa: 1 },
    none:         { pink_cloud: 2, rice_ritual: 2, lumiskin: 1 }
  },
  eye_area: {
    wrinkles:     { eye_genius: 1 },
    dark_circles: { eye_genius: 1 },
    none: {}
  },
  cleanser: {
    balm:  { meltaway: 1 },
    liquid:{ so_simple: 1 },
    none:  {}
  }
};

function pemrf_v5_collectHandles() {
  const scores = window.PEMRF_V5.__scores || {};
  const products = window.PEMRF_PRODUCTS_V5 || {};

  return Object.keys(scores)
    .filter(k => scores[k] > 0)
    .map(k => products[k]?.handle)
    .filter(Boolean);
}

/* ============================================================
   CALCULATE ROUTINE
============================================================ */

function pemrf_v5_calculateRoutine() {
  const scores = {};
  Object.keys(window.PEMRF_PRODUCTS_V5).forEach(k => { scores[k] = 0; });

  Object.entries(PEMRF_SCORING_V5.age[window.PEMRF_V5.answers.age] || {})
    .forEach(([k, v]) => scores[k] += v);

  Object.entries(PEMRF_SCORING_V5.skin_type[window.PEMRF_V5.answers.skin_type] || {})
    .forEach(([k, v]) => scores[k] += v);

  window.PEMRF_V5.answers.concerns.forEach(c => {
    Object.entries(PEMRF_SCORING_V5.concerns[c] || {})
      .forEach(([k, v]) => scores[k] += v);
  });

  Object.entries(PEMRF_SCORING_V5.eye_area[window.PEMRF_V5.answers.eye_area] || {})
    .forEach(([k, v]) => scores[k] += v);

  Object.entries(PEMRF_SCORING_V5.cleanser[window.PEMRF_V5.answers.cleanser] || {})
    .forEach(([k, v]) => scores[k] += v);

  if ("iconic_lips" in scores) {
    scores.iconic_lips = Math.max(scores.iconic_lips, 1);
  }

  pemrf_v5_applyExclusions(scores);

  window.PEMRF_V5.__scores = scores;

  /* ============================================================
     RANDOM ICONIC LIPS SELECTION
  ============================================================ */
  pemrf_v5_selectRandomIconicLips();

  pemrf_v5_showNewsletterStep();
}

/* ============================================================
   SELECT RANDOM ICONIC LIPS VARIANT
============================================================ */

function pemrf_v5_selectRandomIconicLips() {
  const variants = window.PEMRF_ICONIC_LIPS_VARIANTS_V5;
  if (!variants || variants.length === 0) {
    console.warn("No Iconic Lips variants found");
    return;
  }

  // Random selection using existing shuffle function
  const randomVariant = pemrf_v5_shuffle(variants)[0];

  // Store the selected variant
  window.PEMRF_V5.selectedIconicLips = randomVariant;

  console.log("Selected Iconic Lips variant:", randomVariant.handle);
}

/* ============================================================
   EXCLUSIONS – same logic as V2
============================================================ */

function pemrf_v5_applyExclusions(scores) {
  const cleanserChoice = window.PEMRF_V5.answers.cleanser;

  if (cleanserChoice === "balm") {
    scores.so_simple = 0;
  } else if (cleanserChoice === "liquid") {
    scores.meltaway = 0;
  } else if (cleanserChoice === "none") {
    scores.so_simple = 0;
    scores.meltaway = 0;
  }

  pemrf_v5_exclusive(scores, ["day_maker", "perfector"]);
  pemrf_v5_limitMaxOne(scores, ["glass_skin", "pink_cloud", "milky_glow"]);

  pemrf_v5_limitMaxTwo(scores, ["age_expert", "rosie", "purist"]);
  pemrf_v5_limitMaxOne(scores, ["hydrazone", "cosmopolitan", "rice_ritual"]);

  pemrf_v5_limitMaxOne(scores, ["lumiskin", "matcha_spa", "firm_therapy"]);
}

function pemrf_v5_exclusive(scores, pair) {
  const [a, b] = pair;
  if (scores[a] === 0 && scores[b] === 0) return;

  if (scores[a] > scores[b]) scores[b] = 0;
  else if (scores[b] > scores[a]) scores[a] = 0;
  else {
    const pick = pemrf_v5_shuffle([a, b])[0];
    const remove = pick === a ? b : a;
    scores[remove] = 0;
  }
}

function pemrf_v5_limitMaxTwo(scores, group) {
  const picked = group.filter(k => scores[k] > 0);
  if (picked.length <= 2) return;

  // shuffle first so equal scores are broken randomly (sort is stable)
  const sorted = pemrf_v5_shuffle(picked).sort((a, b) => scores[b] - scores[a]);
  const keep = sorted.slice(0, 2);

  group.forEach(k => {
    if (!keep.includes(k)) scores[k] = 0;
  });
}

function pemrf_v5_limitMaxOne(scores, group) {
  const picked = group.filter(k => scores[k] > 0);
  if (picked.length <= 1) return;

  // shuffle first so equal scores are broken randomly (sort is stable)
  const sorted = pemrf_v5_shuffle(picked).sort((a, b) => scores[b] - scores[a]);
  const keep = sorted[0];

  group.forEach(k => {
    if (k !== keep) scores[k] = 0;
  });
}